import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";

function Shell({ title, children }) {
  return (
    <div className="min-h-screen grid place-items-center p-6 bg-[#0B0F17] grid-bg">
      <div className="w-full max-w-sm fade-up">
        <div className="font-display text-lg font-semibold mb-8">Residual<span className="text-emerald-400">Ledger</span></div>
        <h2 className="text-2xl font-semibold tracking-tight mb-6">{title}</h2>
        {children}
        <Link to="/login" className="block mt-6 text-sm text-slate-400 hover:text-slate-200" data-testid="back-to-login">← Back to sign in</Link>
      </div>
    </div>
  );
}

export function ForgotPasscode() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try { const { data } = await api.post("/auth/forgot-passcode", { email }); setMsg(data.message); }
    catch (e2) { setErr(errMsg(e2)); } finally { setBusy(false); }
  };
  return (
    <Shell title="Forgot passcode">
      {msg ? <p className="text-sm text-emerald-300" data-testid="forgot-success">{msg}</p> : (
        <form onSubmit={submit} data-testid="forgot-form">
          <p className="text-sm text-slate-400 mb-5">Enter your login email and we'll send a link to choose a new passcode.</p>
          <Input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-11 bg-[#131B2E]" placeholder="you@company.com" />
          {err && <div className="mt-3 text-sm text-rose-400" data-testid="forgot-error">{err}</div>}
          <Button data-testid="forgot-submit-button" disabled={busy} className="w-full h-11 mt-6 bg-blue-500 hover:bg-blue-600 text-white">{busy ? "Sending…" : "Send reset link"}</Button>
        </form>
      )}
    </Shell>
  );
}

export function ResetPasscode() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (p1 !== p2) return setErr("Passcodes do not match");
    try { await api.post("/auth/reset-passcode", { token: params.get("token") || "", new_passcode: p1 }); setDone(true); setTimeout(() => nav("/login"), 2500); }
    catch (e2) { setErr(errMsg(e2)); }
  };
  return (
    <Shell title="Choose a new passcode">
      {done ? <p className="text-sm text-emerald-300" data-testid="reset-success">Passcode updated. Taking you to sign in…</p> : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <Input data-testid="reset-passcode-input" type="password" required placeholder="New passcode (min 6)" value={p1} onChange={(e) => setP1(e.target.value)} className="h-11 bg-[#131B2E]" />
          <Input data-testid="reset-confirm-input" type="password" required placeholder="Confirm passcode" value={p2} onChange={(e) => setP2(e.target.value)} className="h-11 bg-[#131B2E]" />
          {err && <div className="text-sm text-rose-400" data-testid="reset-error">{err}</div>}
          <Button data-testid="reset-submit-button" className="w-full h-11 bg-blue-500 hover:bg-blue-600 text-white">Save passcode</Button>
        </form>
      )}
    </Shell>
  );
}
